module.exports = __webpack_public_path__ + "media/flags/gy-55fe6747.svg";